import { Card, CardContent } from "@/components/ui/card";
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart";
import { BarChart, Bar, CartesianGrid, XAxis, YAxis } from "recharts";
import { rxGeneratedToday, shiftInfo } from "../../-data/fixtures";
import { ChartColumnBig } from "lucide-react";

export default function RxBarChart() {
  const chartConfig = {
    count: { label: "Rx", color: "#5B5B66" },
  } as const;

  return (
    <Card className="bg-[#FCFCFC] relative border rounded-2xl">
      <div className="px-4 pt-3 flex items-center justify-between">
        <div className="flex items-center text-gray-600">
          <ChartColumnBig className="w-4 h-4" />
          <div className="text-sm ml-1">Rx’s generated today</div>
        </div>
        
      </div>
      <hr className="my-2" />
      <CardContent>
        <div className="grid grid-cols-[85%_15%] gap-4">
          <div className="h-[300px] w-full">
            <ChartContainer config={chartConfig} className="h-full w-full">
              <BarChart data={rxGeneratedToday} margin={{ top: 8, right: 16, left: 16, bottom: 8 }}>
                <CartesianGrid vertical={false} stroke="#E5E7EB" />
                <XAxis dataKey="time" tickLine={false} axisLine={false} tickMargin={8} />
                <YAxis dataKey="count" tickLine={false} axisLine={false} tickMargin={8} />
                <ChartTooltip cursor={false} content={<ChartTooltipContent hideLabel />} />
                <Bar dataKey="count" fill="#5B5B66" radius={6} />
              </BarChart>
            </ChartContainer>
          </div>
          <div className="flex items-end justify-end">
            <div className="bg-[#EBF0F1] rounded-xl px-4 py-3 text-[#60646C]">
              <div className="text-xl font-semibold text-black">{shiftInfo.remainingHours}hrs left</div>
              <div className="text-xs">Before shift change</div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}